import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";



const useQueryPackageRules = (query, pckgId) => {

  const routePage = `/packages/${ pckgId }/rules/`;


  const [ pageSize, setPageSize ] = useState(30);


  let history = useHistory();
  const { numPage } = useParams();


  const { loading, error, data } = useQuery(query, {
    variables: {
      package_id: pckgId,
      first: pageSize,
      page: +numPage ? +numPage : 1,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });



  const packageRules = !loading && data?.packageRules;
  const { paginatorInfo } = !loading && packageRules;
  const { total, currentPage } = !loading && paginatorInfo;


  const pagination = {
    current: currentPage,
    total,
    defaultCurrent: 1,
    defaultPageSize: 10,
  };


  const handleTableChange = (pagination) => {

    setPageSize(pagination.pageSize)

    if (pagination.current === 1)
    {
      history.push(routePage);
    } else
    {
      history.push(`${ routePage }page-${ pagination.current }`);
    }
  }

  return {
    loadingQuery: loading,
    errorQuery: error,
    dataQuery: packageRules.data,
    pagination,
    handleTableChange
  }
};

export default useQueryPackageRules;
